import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { User } from '../../../_models';
import { UserService, AuthenticationService, NotificationService, KeywordService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;

@Component({
  selector: 'app-grant',
  templateUrl: './grant.component.html'
})
export class GrantComponent implements OnInit {

  clientId: any;
  currentUser: User;
  grantList: any = [];
  notGrantedList: any = [];
  selectedGrant: any;
  selectedGrantIdList: any = [];
  oriGrantIdList: any = [];
  loading = true;
  isEmpty = false;
  selectedClient: User;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private keywordSvc: KeywordService,
    private authSvc: AuthenticationService,
    private modalService: NgbModal,
    private notification: NotificationService) {
    this.currentUser = this.authSvc.currentUserValue;
  }

  ngOnInit(): void {
    this.clientId = this.route.snapshot.paramMap.get('id');
    this.loadPage();
    this.userService.getManager(this.clientId).subscribe(data => {
      if (data != null) {
        this.selectedClient = data;
      } else {
        this.notification.showError("Fail to find user detail", "Load Error");
      }
    });
  }

  back() {
    this.router.navigate(['/dashboard/clients']);
  }

  submit() {
    if (this.selectedGrant == undefined) {
      this.notification.showWarning("Please select a keyword to grant.", "Try again");
    } else {
      let abc = this.findBy(this.selectedGrant.id, this.grantList, "id");
      if (abc == undefined) {
        this.notGrantedList = this.notGrantedList.filter(el => el.id !== this.selectedGrant.id);
        this.grantList = this.grantList.concat(this.selectedGrant);
        this.populateGrantedList(this.grantList);
      } else {
        this.notification.showError("This keyword has already been granted.", "Try another");
      }
    }
  }

  unsubmit() {
    if (this.selectedGrant == undefined) {
      this.notification.showWarning("Please select a keyword to unlist the grant.", "Try again");
    } else {
      let abc = this.findBy(this.selectedGrant.id, this.notGrantedList, "id");
      if (abc == undefined) {
        this.grantList = this.grantList.filter(el => el.id !== this.selectedGrant.id);
        this.notGrantedList = this.notGrantedList.concat(this.selectedGrant);
        this.populateGrantedList(this.grantList);
      } else {
        this.notification.showError("This keyword has already been granted.", "Try another");
      }
    }
  }

  onSelect(grant, direction) {
    let thisEl = $('#' + grant.id);
    thisEl.parents().find('.bg-lightgrey').removeClass('bg-lightgrey');
    thisEl.addClass('bg-lightgrey');
    this.selectedGrant = grant;
    if (direction == 'from') {
      $('#fromNotGrant').attr('disabled', false);
      $('#toNotGrant').attr('disabled', 'disabled');
    } else {
      $('#fromNotGrant').attr('disabled', 'disabled');
      $('#toNotGrant').attr('disabled', false);
    }
  }

  log(val) { console.log(val); }

  update() {
    if (this.selectedGrantIdList.length >= 0 && this.oriGrantIdList != this.selectedGrantIdList) {
      this.keywordSvc.addGrant(this.clientId, { ids: this.selectedGrantIdList }).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("List has been updated successfully.", "Updated");
          this.loadPage();
        }
      });
    } else {
      this.notification.showWarning("Nothing to be updated.", "Try Again");
    }
  }

  cancel() {
    this.loadPage();
  }

  removeGrant(id) {
    let temp = this.grantList.filter(el => el.id == id);
    this.grantList = this.grantList.filter(el => el.id !== id);
    this.notGrantedList = this.notGrantedList.concat(temp);
    this.populateGrantedList(this.grantList);
  }

  private loadPage() {
    this.keywordSvc.getGrant(this.clientId).pipe(first()).subscribe(data => {
      if (data.data != null) {
        if (data.data.granted == null) {
          this.grantList = [];
          this.isEmpty = true;
        } else {
          this.grantList = data.data.granted;
          this.populateGrantedList(data.data.granted, "ori");
        }
        if (data.data.notGranted == null) {
          this.notGrantedList = [];
        } else {
          this.notGrantedList = data.data.notGranted;
        }
      } else {
        this.grantList = [];
        this.notGrantedList = [];
        this.isEmpty = true;
      }
      this.loading = false;
      $('#fromNotGrant').attr('disabled', 'disable');
      $('#toNotGrant').attr('disabled', 'disable');
    });
  }

  private populateGrantedList(grantList, from = null) {
    var tempArr = [];
    grantList.map(x => tempArr.push(x.id));
    this.selectedGrantIdList = tempArr;
    if (from == "ori") {
      this.oriGrantIdList = tempArr;
    }
    $('#fromNotGrant').attr('disabled', 'disable');
    $('#toNotGrant').attr('disabled', 'disable');
    this.loading = false;
  }

  private findBy(keyValue, myArray, nameKey) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i][nameKey] === keyValue) {
        return myArray[i];
      }
    }
  }

  private groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

}
